<template>
  <el-card
    class="box-card payment-list-card"
    v-loading="getPaymentsLoading"
    element-loading-text="Loading payments...">
    <el-row
      :gutter="10"
      style="width:100%;margin-top:5px;">
      <el-col :span="12">
        <div class="caption-box">
          <span class="pending-box"></span> = Pending
          <span class="paid-box"></span> = Paid
          <i class="el-icon-warning yellow"></i> = Due in a week or less
          <i class="el-icon-warning red"></i> = Past due
        </div>
      </el-col>
      <el-col :span="12">
        <el-pagination
          :current-page="getPaymentTransactionsPagination.page"
          :page-sizes="getCurrentPageSizes"
          :page-size="getPaymentTransactionsPagination.perPage"
          :total="getPaymentTransactionsPagination.total"
          layout="prev, pager, next, sizes"
          @current-change="handlePaymentListCurrentChange"
          @size-change="handlePaymentListSizeChange">
        </el-pagination>
      </el-col>
    </el-row>
    <br>
    <el-table
      :data="getPaymentTransactions"
      border
      :default-sort = "{prop: 'id', order: 'descending'}"
      style="width: 100%"
      @header-click="sortBy">
      <div slot="empty">No Payment found</div>
      <el-table-column
        label="PO#"
        show-overflow-tooltip
        sortable
        width="130">
        <template slot-scope="scope">
          <router-link
            :to="{ name: 'po-detail', query: {tab: 'payments'},
                   params: { id: scope.row.purchaseOrder.id }}"
            :class="scope.row.paymentStatus == 'paid' ? 'green' : 'yellow'">
            {{ scope.row.purchaseOrder.poId }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column
        label="Payment #"
        show-overflow-tooltip>
        <template slot-scope="scope">
          {{ getPtIndex(scope.row.purchaseOrder.poId, scope.row.id) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Status"
        sortable
        show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag
            style="text-transform:uppercase;"
            v-if="scope.row.status !== 'rejected' && scope.row.status !== 'pending-confirmation'"
            :type="scope.row.status == 'confirmed' ? 'success' : 'warning' ">
            {{ scope.row.status }}
          </el-tag>
          <el-tag
            style="text-transform:uppercase;"
            v-else-if="scope.row.status == 'pending-confirmation'"
            type="primary">
            Pending confirmation
          </el-tag>
          <el-tag
            v-else
            style="text-transform:uppercase;"
            type="danger">
            {{ scope.row.status }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="Due"
        sortable
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.due">
            <span v-if="scope.row.status != 'confirmed'">
              <i
                class="el-icon-warning yellow"
                v-if="checkDueDate(scope.row.due, scope.row.status)"></i>
              <i
                class="el-icon-warning red"
                v-else-if="pastDue(scope.row.due, scope.row.status)"></i>
            </span>
            {{ scope.row.due | moment('DD/MM/YYYY') }}
          </span>
          <span v-else>No due date defined</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Days left"
        show-overflow-tooltip
        width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.due && scope.row.status != 'confirmed'">
            <span v-if="!pastDue(scope.row.due, scope.row.status)">
              {{ scope.row.due | moment("add", "1 day", 'from', 'now') }}
            </span>
            <span
              v-else
              style="color:#E74C3C;">PAST DUE</span>
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Payment"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.amount > 0">{{ scope.row.amount | currency }}</span>
          <span v-else>Not paid yet</span>
        </template>
      </el-table-column>
      <el-table-column
      label="PO Total">
        <template slot-scope="scope" >
          <el-popover
            ref="popover1"
            placement="left"
            title="PAYMENT OBSERVATION:"
            width="100%"
            trigger="hover"
            :content="scope.row.observation">
          </el-popover>
          <span v-popover:popover1>{{ scope.row.purchaseOrderAmount | currency }} </span>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-row
      :gutter="10"
      style="width:100%;">
      <el-col :span="12">
        <div class="caption-box">
          <span class="pending-box"></span> = Pending
          <span class="paid-box"></span> = Paid
          <i class="el-icon-warning yellow"></i> = Due in a week or less
          <i class="el-icon-warning red"></i> = Past due
        </div>
      </el-col>
      <el-col :span="12">
        <el-pagination
          @size-change="handlePaymentListSizeChange"
          @current-change="handlePaymentListCurrentChange"
          :current-page="getPaymentTransactionsPagination.page"
          :page-sizes="getCurrentPageSizes"
          :page-size="getPaymentTransactionsPagination.perPage"
          layout="prev, pager, next, sizes"
          :total="getPaymentTransactionsPagination.total">
        </el-pagination>
      </el-col>

    </el-row>
  </el-card>
</template>

<script>
import * as moment from 'moment';
import { mapGetters } from 'vuex';
import { getDateTimezoneUser, getDateTimezoneChina } from '@/helpers/user-timezone';

export default {
  data() {
    return {
      order: false,
      orderKey: '',
      currentRow: null,
    };
  },
  computed: {
    ...mapGetters({
      getPaymentTransactions: 'getPaymentTransactions',
      getPaymentTransactionsPagination: 'getPaymentTransactionsPagination',
      getPaymentsLoading: 'getPaymentsLoading',
    }),
    getCurrentPageSizes() {
      return [10, 25, 50, 100];
    },
  },
  methods: {
    dateTimezoneUser(date) {
      return getDateTimezoneUser(date);
    },
    dateTimezoneChina(date, showTime) {
      return getDateTimezoneChina(date, showTime);
    },
    pastDue(due, status) {
      if (
        status !== 'confirmed' &&
        moment(due).diff(moment(), 'seconds') < 0 &&
        moment(due).diff(moment(), 'days') !== 0
      ) {
        return true;
      }
      return false;
    },
    checkDueDate(due, status) {
      if (
        (status !== 'confirmed' &&
          moment(due).diff(moment(), 'days') <= 7 &&
          moment(due).diff(moment(), 'seconds') > 0) ||
        moment(due).diff(moment(), 'days') === 0
      ) {
        return true;
      }
      return false;
    },
    getPtIndex(poId, id) {
      const payments = this.getPaymentTransactions;
      const samePoIdArray = payments.filter(o => o.purchaseOrder.poId === poId);
      const itemIndex =
        samePoIdArray
          .map(e => e.id)
          .indexOf(id) + 1;
      return `${itemIndex}/ ${samePoIdArray.length}`;
    },
    sortBy(column) {
      if (typeof column.label !== 'undefined') {
        let key = '';
        let orderBy = '';
        switch (column.label) {
          case 'PO#':
            key = 'id';
            break;
          case 'Status':
            key = 'status';
            break;
          case 'Due':
            key = 'due';
            break;
          case 'Payment Status':
            key = 'paymentStatus';
            break;
          default:
            break;
        }

        if (!this.order) {
          orderBy = `&o=${key}`;
        } else {
          orderBy = `&o=-${key}`;
        }
        if (key !== '') {
          this.orderKey = key;
          this.order = !this.order;
          this.$store.dispatch('updatePaymentTransactionsOrderBy', orderBy);
          this.$store.dispatch('getSearchedPaymentTransactionsData');
        }
      }
    },
    handlePaymentListSizeChange(val) {
      if (val !== this.getPaymentTransactionsPagination.perPage) {
        const paginationObj = {};
        paginationObj.perPage = val;
        paginationObj.page = this.getPaymentTransactionsPagination.page;
        this.$store.dispatch('updatePaymentTransactionsPagination', paginationObj);
        this.$store.dispatch('getSearchedPaymentTransactionsData');
      }
    },
    handlePaymentListCurrentChange(val) {
      if (val !== this.getPaymentTransactionsPagination.page) {
        const paginationObj = {};
        paginationObj.perPage = this.getPaymentTransactionsPagination.perPage;
        paginationObj.page = val;
        this.currentPage = val;
        this.$store.dispatch('updatePaymentTransactionsPagination', paginationObj);
        this.$store.dispatch('getSearchedPaymentTransactionsData', true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-table .info-row {
  background: #c9e5f5;
}

.el-table .positive-row {
  background: #24c5a7;
}
[v-cloak] {
  visibility: hidden;
}
.pointer {
  cursor: pointer;
}
.has-ordered {
  cursor: pointer;
}
.el-upload,
.el-upload-dragger {
  width: 100% !important;
}
.el-upload__input {
  display: none !important;
}
.el-pager li.active {
  background-color: rgba(52, 73, 94, 0.94);
  border-color: rgba(52, 73, 94, 0.94);
}
.table-responsive {
  width: 100%;
}
.payment-list-card .el-table th,
.payment-list-card .el-table th > .cell {
  background-color: #2a3f54;
  color: white;
  cursor: pointer;
  text-align: center;
}
.cell a {
  border-bottom: 1px solid;
  text-decoration: none;
  &.green {
    color: #1abb9c;
    border-color: #1abb9c;
  }
  &.yellow {
    color: #f7ba2a;
    border-color: #f7ba2a;
  }
}
.el-table {
  text-align: center;
}
.paid-box,
.pending-box {
  width: 15px;
  height: 15px;
  display: inline-block;
  margin: 0 5px;
}
.paid-box {
  background-color: #1abb9c;
}
.pending-box {
  background-color: #f7ba2a;
}
.caption-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  i {
    margin: 0 5px;
    font-size: 1.3em;
  }
}
.el-icon-warning.yellow {
  color: #f7ba2a;
}
</style>



// WEBPACK FOOTER //
// src/components/payments/partials/PaymentsList.vue